var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMhubAccounts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.937,2.814H6.063A4.078,4.078,0,0,0,1.989,6.888V17.112a4.078,4.078,0,0,0,4.074,4.074H17.937a4.078,4.078,0,0,0,4.074-4.074V6.888A4.078,4.078,0,0,0,17.937,2.814Zm2.574,14.3a2.577,2.577,0,0,1-2.574,2.574H6.063a2.577,2.577,0,0,1-2.574-2.574V6.888A2.577,2.577,0,0,1,6.063,4.314H17.937a2.578,2.578,0,0,1,2.574,2.574Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "5.54 15.178 8.608 12.11 5.54 12.11 5.54 15.178"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "11.896 15.178 11.896 12.11 8.828 12.11 11.896 15.178"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "12.104 15.178 15.172 12.11 12.104 12.11 12.104 15.178"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18.46 15.178 18.46 12.11 15.392 12.11 18.46 15.178"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "8.608 11.89 8.608 8.822 5.54 11.89 8.608 11.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15.172 11.89 15.172 8.822 12.104 11.89 15.172 11.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "8.828 11.89 11.896 11.89 8.828 8.822 8.828 11.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15.392 11.89 18.46 11.89 15.392 8.822 15.392 11.89"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMhubAccounts);
export default __webpack_public_path__ + "static/media/mhub_accounts.358f85956c4339da7741147d5bf0c764.svg";
export { ForwardRef as ReactComponent };